<template>
  <base-modal
    :title="title"
    :onOpenHook="onOpenHook"
    :onCloseHook="onCloseHook"
    :persistent="editing !== ''"
    modal-width="640px"
    min-height="initial"
    hookSufix="MyProfileModal"
    disableDefaultPadding
  >
    <template #content>
      <v-divider></v-divider>
      <!-- step::initial -->
      <div class="pa-6">
        <!-- avatar -->
        <v-row v-if="!editing.length">
          <v-col cols="6" class="d-flex align-center py-2"
            ><span class="body-regular-smaller">{{
              $t('message.pages.myAccount.profileImage')
            }}</span></v-col
          >
          <v-col cols="6" class="py-2">
            <div class="grid__avatar">
              <template v-if="loading">
                <v-skeleton-loader width="40" height="40" type="image" />
              </template>
              <template v-else>
                <img
                  v-if="hasAvatar"
                  class="grid__avatar--img"
                  :alt="form.name.old"
                  :src="form.avatar.imagePath"
                />
                <v-avatar v-else class="grid__avatar--text" size="100%">
                  <span>
                    {{ userNameInitials }}
                  </span>
                </v-avatar>
                <div class="grid__avatar--ctrl">
                  <label for="avatarImg">
                    <v-icon>mdi-camera</v-icon>
                  </label>
                  <v-divider v-if="hasAvatar" color="white" vertical />
                  <base-btn
                    v-if="hasAvatar"
                    type="tertiary"
                    icon="mdi-delete"
                    @click="deleteImage"
                  />
                </div>
              </template>
            </div>
          </v-col>
        </v-row>

        <v-row v-if="!editing.length">
          <v-col cols="6" class="d-flex align-center py-2">
            <span class="body-regular-smaller">{{
              $t('message.navDrawer.myProfile.name')
            }}</span></v-col
          >
          <v-col cols="6" class="py-2">
            <div class="d-flex ml-auto">
              <template v-if="loading">
                <v-skeleton-loader width="200" type="text" />
              </template>
              <template v-else>
                <v-input
                  :value="isEditingName ? form.name.new : form.name.old"
                  @input="(val) => (form.name.new = val)"
                  autocomplete="false"
                  tabindex="1"
                  hide-details
                  dense
                  @blur="handleEditName"
                />
              </template>
            </div>
          </v-col>
        </v-row>

        <!-- edit::email -->
        <v-row>
          <v-col
            v-if="!editing.length"
            cols="6"
            class="d-flex align-center py-2"
          >
            <div class="body-regular-smaller">
              {{ $t('message.navDrawer.myProfile.email') }}
            </div>
          </v-col>
          <v-col :cols="editing.length ? '12' : '6'" class="py-2">
            <template v-if="editing === 'email'">
              <div class="d-flex flex-column">
                <v-input
                  v-model="form.password.old"
                  :type="show.password.old ? 'text' : 'password'"
                  :label="$t('message.pages.myAccount.currentPassword')"
                  :placeholder="$t('message.pages.myAccount.insertPassword')"
                  :error="errors.password.invalidOldPass"
                  :messages="errorMessageOldPass"
                  autocomplete="false"
                  outlined
                  dense
                  hide-details
                  class="my-8"
                >
                  <template v-slot:append>
                    <v-icon
                      @click="show.password.old = !show.password.old"
                      class="cursor-pointer"
                    >
                      {{
                        show.password.old
                          ? 'mdi-eye-off-outline'
                          : 'mdi-eye-outline'
                      }}
                    </v-icon>
                  </template>
                </v-input>
                <v-input
                  v-model="form.email.new"
                  :label="$t('message.navDrawer.myProfile.email')"
                  :placeholder="$t('message.pages.myAccount.insertNewEmail')"
                  outlined
                  dense
                  hide-details
                  class="mb-8"
                />
                <v-input
                  v-model="form.email.repeat"
                  :label="$t('message.pages.myAccount.confirmNewEmail')"
                  :placeholder="$t('message.pages.myAccount.insertNewEmail')"
                  outlined
                  dense
                  hide-details
                />
              </div>
            </template>
            <template v-else-if="!editing.length">
              <div class="d-flex" @click.stop="toEdit('email')">
                <template v-if="loading">
                  <v-skeleton-loader width="200" type="text" />
                </template>
                <template v-else>
                  <v-input
                    v-model="form.email.old"
                    autocomplete="false"
                    tabindex="2"
                    hide-details
                    outlined
                    dense
                    disabled
                  />
                  <v-icon class="ml-2">mdi-pencil-outline</v-icon>
                </template>
              </div>
            </template>
          </v-col>
        </v-row>
        <!-- edit::phone -->
        <v-row class="d-flex align-center">
          <v-col
            v-if="!editing.length"
            cols="6"
            class="d-flex align-center py-2"
          >
            <span class="body-regular-smaller">
              {{ $t('message.navDrawer.myProfile.phone') }}
            </span></v-col
          >
          <v-col :cols="editing.length ? '12' : '6'" class="py-2">
            <template v-if="editing === 'phone'">
              <div class="d-flex flex-column">
                <v-input
                  v-if="editing !== 'phone'"
                  v-model="form.password.old"
                  :type="show.password.old ? 'text' : 'password'"
                  autocomplete="false"
                  :error="errors.password.invalidOldPass"
                  :messages="errorMessageOldPass"
                  :label="$t('message.pages.myAccount.changePassword')"
                  outlined
                  :placeholder="$t('message.pages.myAccount.insertPassword')"
                  dense
                  hide-details
                  class="mb-6 mt-4"
                >
                  <template v-slot:append>
                    <v-icon
                      @click="show.password.old = !show.password.old"
                      class="cursor-pointer"
                    >
                      {{
                        show.password.old
                          ? 'mdi-eye-off-outline'
                          : 'mdi-eye-outline'
                      }}
                    </v-icon>
                  </template>
                </v-input>
                <v-input
                  v-model="form.password.old"
                  :type="show.password.old ? 'text' : 'password'"
                  autocomplete="false"
                  :error="errors.password.invalidOldPass"
                  :messages="errorMessageOldPass"
                  :label="$t('message.pages.myAccount.changePassword')"
                  outlined
                  :placeholder="$t('message.pages.myAccount.insertPassword')"
                  dense
                  hide-details
                  class="mb-6 mt-4"
                >
                  <template v-slot:append>
                    <v-icon
                      @click="show.password.old = !show.password.old"
                      class="cursor-pointer"
                    >
                      {{
                        show.password.old
                          ? 'mdi-eye-outline-off'
                          : 'mdi-eye-outline'
                      }}
                    </v-icon>
                  </template>
                </v-input>
                <v-input
                  v-model="form.phone.new"
                  v-mask="['+#############']"
                  :label="$t('message.navDrawer.myProfile.phone')"
                  outlined
                  dense
                  hide-details
                  class="mb-6"
                  :disabled="loading"
                />
                <v-input
                  v-model="form.phone.repeat"
                  v-mask="['+#############']"
                  :label="$t('message.pages.myAccount.confirmPhone')"
                  outlined
                  dense
                  hide-details
                  class="mb-6"
                  :disabled="loading"
                />
              </div>
            </template>
            <template v-else-if="!editing.length">
              <div class="d-flex ml-auto" @click.stop="toEdit('phone')">
                <template v-if="loading">
                  <v-skeleton-loader width="200" type="text" />
                </template>
                <template v-else>
                  <v-input
                    v-model="form.phone.old"
                    autocomplete="false"
                    v-mask="['+#############']"
                    tabindex="2"
                    hide-details
                    outlined
                    dense
                    disabled
                  />
                  <v-icon class="ml-2">mdi-pencil-outline</v-icon>
                </template>
              </div>
            </template>
            <div
              v-if="isEditingPassword && !successfulChange"
              class="changePass"
            >
              <v-input
                v-model="form.password.old"
                autocomplete="false"
                :type="show.password.old ? 'text' : 'password'"
                :label="$t('message.pages.myAccount.currentPassword')"
                outlined
                :placeholder="$t('message.pages.myAccount.insertPassword')"
                :append-icon="
                  show.password.old ? 'mdi-eye-outline' : 'mdi-eye-off-outline'
                "
                dense
                hide-details
                class="mb-6 mt-4"
                :disabled="loading"
                @click:append="show.password.old = !show.password.old"
              >
                <template v-slot:append>
                  <v-icon
                    @click="show.password.old = !show.password.old"
                    class="cursor-pointer"
                  >
                    {{
                      show.password.old
                        ? 'mdi-eye-off-outline'
                        : 'mdi-eye-outline'
                    }}
                  </v-icon>
                </template>
              </v-input>
              <v-input
                v-model.trim="form.password.new"
                :label="$t('message.pages.myAccount.changePassword')"
                autocomplete="false"
                :placeholder="$t('message.pages.myAccount.insertNewPassword')"
                tabindex="1"
                class="mb-4"
                hide-details
                outlined
                dense
                :disabled="loading"
                :append-icon="
                  show.password.new ? 'mdi-eye-outline' : 'mdi-eye-off-outline'
                "
                :type="show.password.new ? 'text' : 'password'"
                @click:append="show.password.new = !show.password.new"
              />
              <v-row no-gutters class="mb-8 mustHave">
                <v-col cols="12" class="mb-2">
                  <div class="body-label-xs">
                    {{ $t('message.pages.login.itMustHave') }}
                  </div>
                </v-col>
                <v-col
                  v-for="({ check, label }, index) in passwordChecks"
                  :key="index"
                  cols="12"
                  class="mb-2"
                >
                  <v-row no-gutters>
                    <v-icon :color="check ? 'green' : ''" small size="16">
                      mdi-check-circle
                    </v-icon>
                    <span class="ml-2 body-regular-smaller">{{ label }}</span>
                  </v-row>
                </v-col>
              </v-row>
              <!-- password::confirm -->
              <v-input
                v-model.trim="form.password.repeat"
                autocomplete="false"
                :label="$t('message.pages.myAccount.confirmPassword')"
                tabindex="2"
                outlined
                dense
                :placeholder="$t('message.pages.myAccount.insertNewPassword')"
                :disabled="loading"
                :messages="errorMessage"
                :error="
                  errors.password.minError ||
                  errors.password.notSafeError ||
                  errors.password.invalidPassword ||
                  errors.password.limitExceeded
                "
                :append-icon="
                  show.password.repeat
                    ? 'mdi-eye-outline'
                    : 'mdi-eye-off-outline'
                "
                :type="show.password.repeat ? 'text' : 'password'"
                @click:append="show.password.repeat = !show.password.repeat"
                @keyup.enter="handleChangePass"
              >
                <template v-slot:message="{ message }">
                  <span
                    v-if="
                      errors.password.minError ||
                      errors.password.notSafeError ||
                      errors.password.invalidPassword ||
                      errors.password.limitExceeded
                    "
                    class="red--text caption align-text"
                  >
                    <v-icon color="red" size="18">mdi-alert-circle</v-icon>
                    <span>{{ message }}</span>
                  </span>
                </template>
              </v-input>
            </div>
          </v-col>
        </v-row>
      </div>

      <v-divider v-if="!editing.length"></v-divider>

      <!-- file -->
      <aside class="hidden">
        <v-file-input
          id="avatarImg"
          accept="image/png, image/jpeg, image/jpg, image/gif"
          @change="handleUpload"
        />
      </aside>
      <v-list class="py-0" v-if="!editing.length">
        <v-list-item class="px-6 py-2" @click="toEdit('password')">
          <v-list-item-title class="body-bold-smaller">{{
            $t('message.pages.myAccount.actionChangePassword')
          }}</v-list-item-title>
          <v-icon>mdi-arrow-right</v-icon>
        </v-list-item>
        <template>
          <v-list-item
            class="px-6 py-2 d-flex justify-space-between align-center"
            @click="openTwoFactorAuth"
          >
            <v-list-item-title class="body-bold-smaller">
              {{ $t('message.pages.myAccount.twoFactorAuth') }}
            </v-list-item-title>

            <div class="d-flex">
              <v-tag :type="mfaSettings.app ? 'success' : 'neutral'">
                <template v-if="mfaSettings.app">
                  <v-icon>mdi-check-circle</v-icon>
                </template>
                {{ $t('message.2fa.authenticationApp') }}
              </v-tag>
              <v-tag
                :type="mfaSettings.sms ? 'success' : 'neutral'"
                class="ml-2"
              >
                <template v-if="mfaSettings.sms">
                  <v-icon>mdi-check-circle</v-icon>
                </template>
                {{ $t('message.2fa.SMS') }}
              </v-tag>
              <v-icon>mdi-arrow-right</v-icon>
            </div>
          </v-list-item>
        </template>
      </v-list>
      <v-divider></v-divider>
    </template>
    <template #card-actions>
      <div class="d-flex justify-end pa-6">
        <template v-if="editing">
          <base-btn
            type="tertiary"
            @click="handleCancelEdit"
            :disabled="isLoadingChange"
            >{{ $t('message.actions.return') }}</base-btn
          >
          <base-btn
            class="ml-2"
            @click="handleSave"
            :disabled="isLoadingChange"
            :loading="isLoadingChange"
            >{{ $t('message.actions.change') }}
            {{ $t(`message.pages.myAccount.${editing}`) }}</base-btn
          >
        </template>
        <template v-else>
          <base-btn type="tertiary" @click="handleClose">{{
            $t('message.actions.cancel')
          }}</base-btn>
          <base-btn class="ml-2" @click="handleSave">{{
            $t('message.actions.save')
          }}</base-btn>
        </template>
      </div>
    </template>
  </base-modal>
</template>

<script>
// external imports
import _ from 'lodash'

// internal imports
import { mapState, mapMutations, mapActions } from 'vuex'

// API
import imagesAPI from '@/services/imagesApi.js'
import planApi from '@/services/planApi'

export default {
  name: 'TheMyProfile',
  components: {
    BaseModal: () => import('@/components/BaseModal.vue'),
    BaseBtn: () => import('@/components/BaseBtn.vue'),
  },
  data: () => ({
    open: false,
    isBeta: false,
    editing: '',
    step: 0,
    loading: false,
    isLoadingChange: false,
    successfulChange: false,
    isEditingName: false,
    form: {
      avatar: {
        file: {},
        imageId: '',
        imagePath: '',
      },
      name: {
        old: '',
        new: '',
      },
      phone: {
        old: '',
        new: '',
      },
      email: {
        old: '',
        new: '',
        repeat: '',
      },
      password: {
        old: '',
        new: '',
        repeat: '',
        forgetSessions: true,
      },
    },
    show: {
      password: {
        new: false,
        repeat: false,
        old: false,
      },
    },
    errors: {
      password: {
        minError: false,
        notSafeError: false,
        invalidPassword: false,
        limitExceeded: false,
        expiredCode: false,
        invalidOldPass: false,
      },
      email: {
        generalError: false,
        invalidEmail: false,
        invalidPass: false,
        customErrorMessage: '',
      },
      API: {
        message: '',
      },
    },
  }),
  computed: {
    ...mapState('user', {
      userInfo: (state) => state.userInfo,
      userPlanInfo: (state) => state.userPlanInfo.user,
      userAllInfo: (state) => state.userAllInfo,
    }),
    isEditingNameOrPhone() {
      return ['name', 'phone'].includes(this.editing)
    },
    isEditingEmail() {
      return this.editing === 'email'
    },
    isEditingPassword() {
      return this.editing === 'password'
    },
    title() {
      if (this.isEditingEmail || this.isEditingPassword) {
        const prefix = this.$t('message.actions.change')
        const suffix = this.isEditingEmail
          ? this.$t('message.navDrawer.myProfile.email')
          : this.$t('message.navDrawer.myProfile.password')

        return `${prefix} ${suffix}`
      }

      return this.$t('message.navDrawer.myProfile.title')
    },
    confirmLabel() {
      return this.isEditingEmail
        ? this.$t('message.navDrawer.myProfile.password')
        : this.$t('message.pages.myAccount.currentPassword')
    },
    errorMessage() {
      const i18n = this.$i18next

      if (this.errors.password.minError) {
        return i18n.t('message.errors.minError')
      }

      if (
        this.errors.password.notSafeError ||
        this.errors.password.invalidPassword
      ) {
        return i18n.t('message.errors.notSafeError')
      }

      if (this.errors.password.limitExceeded) {
        return i18n.t('message.errors.limitExceeded')
      }

      if (this.errors.password.expiredCode) {
        return i18n.t('message.errors.expiredCode')
      }

      if (this.errors.email.generalError) {
        return i18n.t('message.errors.unexpectedError')
      }

      if (this.errors.email.invalidPass) {
        return i18n.t('message.invalidPassword')
      }

      if (this.errors.email.invalidEmail) {
        return i18n.t('message.errors.invalidEmail')
      }

      if (this.errors.email.customErrorMessage) {
        return i18n.t(
          `message.pages.myAccount.errors.${this.errors.email.customErrorMessage}`
        )
      }

      return ''
    },
    errorMessageOldPass() {
      if (this.errors.password.invalidOldPass) {
        return this.$i18next.t('message.errors.invalidOldPassword')
      }
      return ''
    },
    checkPasswordHasNumber() {
      const regex = new RegExp('^((?=.*[0-9]))')
      const regexTest = regex.test(this.form.password.new)
      return regexTest
    },
    checkMinimumCharacters() {
      const regex = new RegExp('^((?=.{8,}))')
      const regexTest = regex.test(this.form.password.new)
      return regexTest
    },
    checkSpecialCharacters() {
      const regex = new RegExp('^((?=.*[!@#$%^&*]))')
      const regexTest = regex.test(this.form.password.new)
      return regexTest
    },
    checkPasswordAreEquals() {
      return (
        this.form.password.new &&
        _.isEqual(this.form.password.new, this.form.password.repeat)
      )
    },
    checkLetters() {
      const regex = new RegExp('^((?=.*[a-z])(?=.*[A-Z]))')
      const regexTest = regex.test(this.form.password.new)
      return regexTest
    },
    checkEmail() {
      const value = this.form.email.new
      const i18n = this.$i18next

      if (value && /^[\w-+.]+@([\w-]+\.)+[\w-]{2,4}$/g.test(value)) return true

      return i18n.t('message.invalidEmail')
    },
    areEmailsEqual() {
      return _.isEqual(this.form.email.new, this.form.email.repeat)
    },
    isSafePassword() {
      return (
        this.checkPasswordHasNumber &&
        this.checkMinimumCharacters &&
        this.checkSpecialCharacters &&
        this.checkLetters &&
        _.isEqual(this.form.password.new, this.form.password.repeat)
      )
    },
    isEmailValid() {
      return (
        this.checkEmail === true &&
        this.form.email.new !== this.userPlanInfo.email
      )
    },
    passwordChecks() {
      const i18n = this.$i18next
      return {
        0: {
          check: this.checkPasswordHasNumber,
          label: i18n.t('message.pages.login.numbers'),
        },
        1: {
          check: this.checkMinimumCharacters,
          label: i18n.t('message.pages.login.minCharacters'),
        },
        2: {
          check: this.checkSpecialCharacters,
          label: i18n.t('message.pages.login.specialCharacters'),
        },
        3: {
          check: this.checkLetters,
          label: i18n.t('message.pages.login.differentLetters'),
        },
      }
    },
    emailChecks() {
      const i18n = this.$i18next
      const newEmail = this.form.email.new
      const userEmail = this.userPlanInfo['email']

      return {
        0: {
          check: userEmail !== newEmail && newEmail,
          label: i18n.t(
            'message.pages.myAccount.emailRequirements.differentFromCurrent'
          ),
        },
        1: {
          check: this.isEmailValid,
          label: i18n.t('message.pages.myAccount.emailRequirements.valid'),
        },
      }
    },
    successfulMessage() {
      const i18n = this.$i18next
      let message = ''

      if (this.isEditingPassword)
        message = i18n.t('message.pages.myAccount.successfulPassword')

      if (this.isEditingEmail) {
        switch (this.step) {
          // asking to check inbox
          case 2:
            message = i18n.t(
              'message.pages.myAccount.modals.description.confirmChangeEmail'
            )
            break

          // successful change + asking if logoff
          case 3:
            message = `${i18n.t(
              'message.pages.myAccount.successfulEmail'
            )} ${i18n.t('message.pages.myAccount.forgetEmailSession')}`
            break

          // logged off
          case 5:
            message = i18n.t(
              'message.pages.myAccount.modals.description.doneLogoutSessions'
            )
            break

          default:
            // do nothing
            break
        }
      }

      return message
    },
    showEmailValidation() {
      return (
        this.userPlanInfo &&
        this.userPlanInfo.hasOwnProperty('email') &&
        !this.loading
      )
    },
    hasAvatar() {
      return !!this.form.avatar.imageId && !!this.form.avatar.imagePath
    },
    userNameInitials() {
      const { name, email } = this.userPlanInfo ?? {}
      let initials = ''

      if (name) initials = name
      else if (email) initials = email

      if (initials) {
        return initials
          .match(/(^\S\S?|\s\S)?/g)
          .map((v) => v.trim())
          .join('')
          .match(/(^\S|\S$)?/g)
          .join('')
          .toLocaleUpperCase()
      }

      return initials
    },
    mfaSettings() {
      return {
        app: this.userAllInfo?.mfa_methods?.includes('app') || false,
        sms: this.userAllInfo?.mfa_methods?.includes('sms') || false,
      }
    },
  },
  watch: {
    editing(newValue, oldValue) {
      const newIsNull = newValue === ''
      const newIsName = newValue === 'name'
      const newIsPhone = newValue === 'phone'
      const oldIsNull = oldValue === ''

      if ((newIsName || newIsPhone) && oldIsNull && !this.editing) {
        window.addEventListener('click', this.handleClickOutside)
      } else if (newIsNull) {
        window.removeEventListener('click', this.handleClickOutside)
      }

      if (newIsNull) {
        this.resetObject(this.show.password, false)
        this.step = 0
        this.loading = false
        this.successfulChange = false
      }
    },
    step() {
      window.removeEventListener('click', this.handleClickOutside)
    },
  },
  methods: {
    ...mapActions('session', [
      'signInUser',
      'updateEmailAddress',
      'confirmUpdateEmailAddress',
      'getUserDataByID',
      'updateUserAvatar',
    ]),
    ...mapActions('user', ['updateUser']),
    ...mapMutations('user', [
      'UPDATE_USER_PLAN_INFO_ATTRIBUTES',
      'UPDATE_USER_ALLINFO_IMAGE',
      'UPDATE_USER_ALLINFO_NAME',
      'UPDATE_GLOBAL_SNACKBAR',
    ]),
    onOpenHook(data = null) {
      window.removeEventListener('click', this.handleClickOutside)
      this.$root.$emit('resetIsAnyOtherModal', true)

      this.isBeta = location.search.match('beta')
      this.getUserData()

      if (data) {
        const { editing, ...rest } = data
        if (editing) this.handleSuccess({ editing, ...rest })

        if (rest.error) {
          this.errors.API.message = rest.error.detail
        }
      }
    },
    onCloseHook() {
      this.$root.$emit('resetIsAnyOtherModal')

      // remove docs listeners
      window.removeEventListener('click', this.handleClickOutside)

      // reset modal data
      this.resetObject(this.form.name, '')
      this.resetObject(this.form.phone, '')
      this.resetObject(this.form.email, '')
      this.resetObject(this.form.password, '')

      // redirect to Videos page if email success or error message
      if ([3, 7, 8].includes(this.step)) this.$router.push({ name: 'Videos' })

      this.toEdit('')
    },
    resetObject(obj, value) {
      const _ignore = ['forgetSessions']
      Object.keys(obj).forEach((e) => {
        if (!_ignore.includes(e)) obj[e] = value
      })
    },
    handleClickOutside(e) {
      const closest = (target) => e.target.closest(target)

      if (this.editing) return

      if (closest('.v-overlay__scrim')) return

      if (!this.loading && !closest('.edit')) {
        this.handleDifferData()
        this.toEdit('')
      }
    },
    handleClose() {
      this.$root.$emit('closeMyProfileModal')
    },
    toEdit(value, step = 1) {
      this.editing = value

      if (['name', 'phone'].includes(value)) this.handleDifferData()
      else if (value !== '') this.step = step
      else if (value === '') this.step = 1
    },
    handleDifferData() {
      const target = this.editing

      if (this.form[target].old !== this.form[target].new) {
        this.form[target].new = this.form[target].old
      }
    },
    async handleEditName() {
      const oldValue = this.form.name.old
      const newValue = this.form.name.new

      // prevent edit if no changes
      if (newValue === oldValue) {
        this.isEditingName = false
        return
      }

      try {
        this.loading = true
        this.isLoadingChange = true

        const { data } = await this.updateUserAvatar({ name: newValue })

        this.UPDATE_USER_PLAN_INFO_ATTRIBUTES(data.response)
        await this.getUserData('name')
        this.$root.$emit('updateAlluserPlanInfo')
        this.UPDATE_USER_ALLINFO_NAME(newValue)

        this.UPDATE_GLOBAL_SNACKBAR({
          open: true,
          text: this.$t('message.pages.myAccount.nameSuccessful'),
          type: 'success',
          timeout: 3000,
        })
      } catch (err) {
        console.error('editing-name', err)
      } finally {
        this.loading = false
        this.isLoadingChange = false
        this.isEditingName = false
      }
    },
    async handleEditData() {
      const target = this.editing.length ? this.editing : 'name'
      const params = {}
      const oldValue = this.form[target].old
      const newValue = this.form[target].new

      // prevent edit if no changes
      if (newValue === oldValue) return this.toEdit('')

      params[target] = newValue

      try {
        this.loading = true

        const { data } = await this.updateUserAvatar(params)

        this.UPDATE_USER_PLAN_INFO_ATTRIBUTES(data.response)
        await this.getUserData(target)
        this.$root.$emit('updateAlluserPlanInfo')
        this.UPDATE_USER_ALLINFO_NAME(this.form.name.new)
        this.toEdit('')
      } catch (err) {
        console.error(`editing-${target}`, err)
      } finally {
        this.loading = false
      }
    },
    handleSuccess({ editing = '', step = null, success = null } = {}) {
      this.editing = editing
      this.isLoadingChange = true
      if (step !== null) {
        this.isLoadingChange = true
        this.step = step
      }
      if (success !== null) {
        this.isLoadingChange = false
        this.successfulChange = success
      }
      this.isLoadingChange = false
      this.handleClose()
    },
    async handleConfirmClick() {
      if (this.isEditingPassword) return await this.handleChangePass()

      if (this.isEditingEmail) {
        switch (this.step) {
          case 1:
            await this.handleChangeEmail()
            break

          case 4:
            await this.handleLogoff()
            break

          default:
            // do nothing
            break
        }
      }
    },
    async handleLogin(customPassword = null) {
      try {
        const loginData = await this.signInUser({
          username: this.userPlanInfo.email,
          password: customPassword ?? this.form.password.new,
        })

        this.updateUser({
          email: loginData.attributes.email,
          id: loginData.attributes.sub,
          name: loginData.attributes.name ?? loginData.attributes.email,
        })
      } catch (err) {
        console.error('LOGIN ', err)
      }
    },
    async handleChangePass() {
      this.successfulChange = false
      this.isLoadingChange = true
      this.resetObject(this.errors.password, false)

      if (this.form.password.new === '' || this.form.password.repeat === '') {
        this.errors.password.notSafeError = true
        this.isLoadingChange = false
        this.loading = false
        return
      }

      if (this.form.password.new.length < 8 || this.form.password.repeat < 8) {
        this.errors.password.minError = true
        this.isLoadingChange = false
        this.loading = false
        return
      }

      try {
        this.loading = true

        await this.$store.dispatch('session/changePassword', {
          newPass: this.form.password.new,
          oldPass: this.form.password.old,
        })

        if (this.form.password.forgetSessions) {
          await this.$store.dispatch('session/forgetSessions', true)
          await this.handleLogin()
        }

        // reset password fields
        this.resetObject(this.form.password, '')
        this.resetObject(this.show.password, false)
        this.successfulChange = true
        this.UPDATE_GLOBAL_SNACKBAR({
          open: true,
          text: this.$t(`message.pages.myAccount.${this.editing}Successful`),
          type: 'success',
          timeout: 3000,
        })
        this.isLoadingChange = false
        this.toEdit('')
      } catch (error) {
        console.error(error)

        if (error.code === 'NotAuthorizedException') {
          this.errors.password.invalidOldPass = true
          console.log(this.errors.password.invalidOldPass)
        }
        if (error.code === 'LimitExceededException') {
          this.errors.password.limitExceeded = true
        }

        this.loading = false
      }

      this.loading = false
    },
    async handleChangeEmail() {
      this.isLoadingChange = true
      const password = this.form.password.old
      if (!this.isEmailValid) {
        this.isLoadingChange = false
        return
      }

      if (this.form.email.new === this.userInfo.email) {
        this.isLoadingChange = false
        return
      }

      this.errors.email.invalidPass = false
      this.errors.email.generalError = false

      try {
        const { new: newEmail } = this.form.email

        this.loading = true

        await this.signInUser({
          username: this.userInfo.email,
          password,
        })
        await this.updateEmailAddress({ newEmail, beta: 1 })

        this.successfulChange = true
        this.isLoadingChange = false
        this.resetObject(this.form.email, '')
        this.toEdit('')
      } catch (err) {
        console.error(err)

        if (err?.code === 'NotAuthorizedException') {
          // padrão de erro do cognito
          this.errors.email.invalidPass = true
        } else if (err?.response?.data?.errMsg) {
          // padrão de erro da nossa API
          this.errors.email.customErrorMessage = err.response.data.errMsg
        } else {
          this.errors.email.generalError = true
        }
      } finally {
        this.isLoadingChange = false
        this.loading = false
      }
    },
    async handleLogoff() {
      const password = this.form.password.old

      this.errors.email.invalidPass = false
      this.errors.email.generalError = false

      try {
        this.loading = true

        await this.signInUser({
          username: this.userPlanInfo.email,
          password,
        })

        await this.$store.dispatch('session/forgetSessions', true)
        await this.handleLogin(password)

        this.successfulChange = true
        this.toEdit('email', 5)
      } catch (err) {
        console.error(err)

        if (err?.code === 'NotAuthorizedException') {
          // padrão de erro do cognito
          this.errors.email.invalidPass = true
        } else if (err?.response?.data?.errMsg) {
          // padrão de erro da nossa API
          this.errors.email.customErrorMessage = err.response.data.errMsg
        } else {
          this.errors.email.generalError = true
        }
      } finally {
        this.loading = false
      }
    },
    async getUserData(updating = 'all') {
      this.loading = true
      this.isLoadingChange = true
      try {
        const dataUser = await this.getUserDataByID()
        const dataSubscription = await planApi.getSubscription()

        if (['all', 'avatar'].includes(updating)) {
          this.form.avatar.imagePath = dataUser.data.image_path
          this.form.avatar.imageId = dataUser.data.image_id
        }

        if (['all', 'name'].includes(updating)) {
          this.form.name.old = dataUser.data.name
          this.form.name.new = ''
        }

        if (['all', 'phone'].includes(updating)) {
          this.form.phone.old =
            dataUser.data.phone || dataSubscription.data.phone
          this.form.phone.new = ''
        }

        if (['all', 'email'].includes(updating)) {
          this.form.email.old = dataUser.data.email
          this.form.email.new = ''
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
        this.isLoadingChange = false
      }
    },
    async handleUpload(file) {
      this.form.avatar.file = file
      await this.saveImage()
    },
    async deleteImage() {
      if (this.form.avatar.imageId) {
        this.loading = true

        await imagesAPI.deleteImage(this.form.avatar.imageId)
        await this.getUserData('avatar')
        this.UPDATE_USER_ALLINFO_IMAGE(false)

        this.loading = false
      }
    },
    async saveImage() {
      if (this.form.avatar.imagePath) await this.deleteImage()

      const data = new FormData()
      data.append('file', this.form.avatar.file)
      var reader = new FileReader()
      reader.readAsDataURL(this.form.avatar.file)
      reader.onload = async () => {
        const options = [
          {
            filename: this.form.avatar.file.name,
            type: 'template',
          },
        ]
        const data = await fetch(reader.result)
        const blobData = await data.blob()

        try {
          this.loading = true

          const ret = await imagesAPI.handleUploadImage(blobData, options)

          await this.updateUserAvatar({ image_id: ret.id })
          await this.getUserData('avatar')
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
          this.form.avatar.file = {}
          this.UPDATE_USER_ALLINFO_IMAGE(this.form.avatar.imagePath)
        }
      }
    },
    handleCancelEdit() {
      this.toEdit('')
      this.resetObject(this.form[this.editing], '')
    },
    async handleSave() {
      if (this.editing) {
        if (this.editing === 'phone') {
          try {
            this.loading = true
            this.isLoadingChange = true

            const { data } = await this.updateUserAvatar({
              phone: this.form.phone.new,
            })

            this.UPDATE_USER_PLAN_INFO_ATTRIBUTES(data.response)
            await this.getUserData('phone')
            this.$root.$emit('updateAlluserPlanInfo')

            this.UPDATE_GLOBAL_SNACKBAR({
              open: true,
              text: this.$t('message.pages.myAccount.phoneSuccessful'),
              type: 'success',
              timeout: 3000,
            })

            this.toEdit('')
          } catch (error) {
            console.error('Erro ao atualizar telefone:', error)
            this.UPDATE_GLOBAL_SNACKBAR({
              open: true,
              text: this.$t('message.errors.unexpectedError'),
              type: 'error',
              timeout: 3000,
            })
          } finally {
            this.loading = false
            this.isLoadingChange = false
          }
        } else {
          this.handleConfirmClick()
        }
      } else {
        this.handleClose()
      }
    },
    toggleNameEdit() {
      this.isEditingName = !this.isEditingName
      if (this.isEditingName) {
        this.form.name.new = this.form.name.old
      }
    },
    openTwoFactorAuth() {
      this.$root.$emit('openTwoFactorAuth', { fromProfile: true })
      this.handleClose()
    },
  },
}
</script>
<style lang="scss">
.mustHave {
  padding: 1rem;
  background-color: varFigma(neutral-99);

  .v-icon {
    color: varFigma(neutral-80-lighter);
  }
}
</style>
<style lang="scss" scoped>
.hidden {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;

  width: 0.1px;
  height: 0.1px;
  overflow: hidden;
  opacity: 0;
}

.grid {
  display: grid;

  &__avatar {
    $size: 40px;

    position: relative;

    display: flex;
    width: $size;
    height: $size;
    border: 1px solid var(--v-neutral-lighten3);
    border-radius: 100%;

    align-items: center;
    justify-content: center;
    overflow: hidden;

    &--img {
      object-fit: cover;
      width: 100%;
      height: 100%;
    }
    &--text {
      background-color: varFigma(brand-60-base);

      font-size: 1rem;
      color: #fff;
    }

    &--ctrl {
      display: none;
      background: rgba(0, 0, 0, 0.8);

      &::v-deep {
        .v-divider {
          $size: 60%;

          margin: 20% 0;

          border-color: rgba(#fff, 0.4);
          max-height: $size;
          min-height: $size;
        }

        label {
          padding: 0.75rem;
          cursor: pointer;
        }

        .base-button {
          $color: rgba(#000, 0);

          background-color: $color !important;
          border-color: $color !important;
        }

        .mdi-camera {
          color: white;
        }

        .mdi-delete {
          color: #ffcdd2;
        }
      }
    }

    &:hover {
      [class*='--ctrl'] {
        position: absolute;
        top: 0;
        right: 0;

        display: flex;
        width: 100%;
        height: 100%;

        align-items: center;
        justify-content: center;
      }
    }
  }

  &__options {
    font-size: 1rem;
    color: var(--v-neutral-base);

    > .d-flex {
      min-height: 50px;
      align-items: stretch;

      &:not(:last-child) {
        box-shadow: inset 0px -1px 0px rgba(0, 0, 0, 0.12);
      }

      > div {
        display: flex;
        align-items: center;
      }
    }

    .edit {
      display: flex;
      align-items: center;

      cursor: pointer;

      .v-icon {
        margin-left: $spacing-minus-2;
        opacity: 0;
      }

      &:hover {
        color: var(--v-neutral-lighten1);

        .v-icon {
          opacity: 1;
        }
      }
    }
  }

  &__step {
    margin: 0 auto;

    font-size: 1rem;
    color: var(--v-neutral-lighten1);

    .v-icon.grey--text {
      color: var(--v-neutral-lighten2) !important;
    }

    &::v-deep {
      [class*='readonly'] {
        .v-input__slot {
          &::before,
          &::after {
            display: none !important;
          }
        }
      }
    }
  }

  &__footer {
    display: flex;
    padding: $spacing-plus-1 $spacing-plus-2 !important;
    background-color: #ffecb3;

    color: var(--v-neutral-base);

    align-items: flex-start;

    &::v-deep {
      .v-input__slot {
        background-color: #fff !important;
      }

      .v-icon {
        color: var(--v-neutral-lighten1);
      }
    }
  }

  &__success {
    margin: 4rem auto 6rem;

    display: flex;
    max-width: 430px;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    color: var(--v-neutral-base);
  }
}
</style>

<style lang="scss">
.bg-dark {
  .grid {
    &__options {
      color: var(--v-neutral-lighten2);

      .edit:hover {
        color: var(--v-neutral-lighten3);
      }
    }

    &__footer {
      .theme--dark.v-input input {
        color: var(--v-neutral-base) !important;
      }
    }
  }
}
</style>
